<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Mínimo Ativações</span>
          <vs-input
            size="large"
            class="w-full"
            name="Mínimo Ativações"
            id="qtdAtivacoesMinimo"
            type="number"
            v-model="formCadastro.qtdAtivacoesMinimo"
            v-validate="{ required: true }"
            :state="validateState('Mínimo Ativações')"
            :danger="validateClass('Mínimo Ativações')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Máximo Ativações</span>
          <vs-input
            size="large"
            class="w-full"
            name="Máximo Ativações"
            id="qtdAtivacoesMaximo"
            type="number"
            v-model="formCadastro.qtdAtivacoesMaximo"
            v-validate="{ required: true }"
            :state="validateState('Máximo Ativações')"
            :danger="validateClass('Máximo Ativações')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Comissionamento</span>
          <vs-input
            size="large"
            class="w-full"
            name="Comissionamento"
            id="porcentagemComissionamento"
            type="number"
            step="0.01"
            v-model="formCadastro.porcentagemComissionamento"
            v-validate="{ required: true }"
            :state="validateState('Comissionamento')"
            :danger="validateClass('Comissionamento')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-percent"
            icon-no-border
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idMeta == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from '../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';

export default {
  props: {
    sideBar: {
      type: Boolean
    },
    dados: {
      type: Object
    }    
  },

  watch: {
    dados() {
      this.preencheForm();
    },
  },

  data() {
    return {
      aguardeCadastro: false,
      languages: lang,
      formCadastro: {
        idMeta: null,
        idProgramaAfiliado: null,
        qtdAtivacoesMinimo: null,
        qtdAtivacoesMaximo: null,
        porcentagemComissionamento: null,
        status: true
      },
    };
  },

  methods: {
    preencheForm() {
      if (this.dados.idMeta) {
        this.formCadastro.idMeta = this.dados.idMeta;
        this.formCadastro.qtdAtivacoesMinimo = this.dados.qtdAtivacoesMinimo;
        this.formCadastro.qtdAtivacoesMaximo = this.dados.qtdAtivacoesMaximo;
        this.formCadastro.porcentagemComissionamento = this.dados.porcentagemComissionamento;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
      } else {
        this.resetForm();
      };

      this.formCadastro.idProgramaAfiliado = this.dados.idProgramaAfiliado;
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      let action, method;
      if (!this.formCadastro.idMeta) {
        action = 'adicionar';
        method = 'post';
      } else {
        action = `atualizar/${this.formCadastro.idMeta}`;
        method = 'put';
      };

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            [method]('programa-afiliados-metas', action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },

    resetForm() {
      this.formCadastro = {
        idMeta: null,
        qtdAtivacoesMinimo: null,
        qtdAtivacoesMaximo: null,
        porcentagemComissionamento: null,
        status: true
      };
    },

    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },

  mounted() {
    this.$validator.localize('ptBr', locale);
  },

  components: {
    BotaoSubmit
  },
};
</script>
<!------------ END SCRIPT ------------>
